import React from 'react';
import { Card, CardContent, Typography, Grid } from '@material-ui/core';
import GridItem from 'components/Grid/GridItem.jsx';
import sqLogo from 'assets/img/sure_quote_website_logo.png';
import { propertyMapping } from './objects';

const SearchedPdf = props => {
	return (
		<div style={{ margin: '20px' }}>
			<div style={{ textAlign: 'center' }}>
				<img
					style={{ width: '250px', margin: '0px auto' }}
					src={sqLogo}
					alt="sqLogo"
				/>
			</div>

			<Typography
				variant="headline"
				className="centerCell"
				style={{ marginBottom: '15px' }}
			>
				Client Search
			</Typography>
			<Grid container>
				{props.clients.map(client => {
					return (
						<GridItem xs={12} sm={12} md={12} style={{ marginBottom: '15px' }}>
							<Card
								key={client.id}
								style={{ boxShadow: 'none', border: '1px solid #afafaf' }}
							>
								<CardContent>
									<Grid container>
										{Object.keys(propertyMapping).map(key => {
											if (!props.selectedProperties.includes(key)) {
												return null;
											} else {
												return (
													<React.Fragment key={key}>
														<GridItem
															xs={6}
															sm={6}
															md={6}
															style={{ marginBottom: '5px' }}
														>
															<Typography
																style={{
																	textAlign: 'left',
																	wordBreak: 'break-word'
																}}
															>
																<strong>{`${key}  :`}</strong>
															</Typography>
														</GridItem>
														<GridItem
															xs={6}
															sm={6}
															md={6}
															style={{ marginBottom: '5px' }}
														>
															<Typography
																key={key}
																style={{
																	textAlign: 'left',
																	wordBreak: 'break-word'
																}}
															>
																{client[propertyMapping[key]]
																	? client[propertyMapping[key]]
																	: 'N/A'}
															</Typography>
														</GridItem>
													</React.Fragment>
												);
											}
										})}
									</Grid>
								</CardContent>
							</Card>
						</GridItem>
					);
				})}
			</Grid>
		</div>
	);
};

export default SearchedPdf;



// WEBPACK FOOTER //
// ./src/views/Clients/components/advanced_search/SearchedPdf.jsx